import React, { useState } from 'react';

import { debounce } from 'lodash';

import { ChipLoader } from 'components/v2';

import FiltersSelectHeader from '../FiltersSelectHeader';

import FilterPatientFormData from './FilterPatientFormData';

interface FilterPatientFormProps {
  type: 'forms' | 'schedulingPlus' | 'ccdaForms' | 'formName';
}

const FilterPatientForm: React.FC<FilterPatientFormProps> = ({ type = 'forms' }) => {
  const [regex, setRegex] = useState<string>('');
  const patientFormType = {
    forms: 'intake',
    schedulingPlus: 'preQualification',
    ccdaForms: 'ccda',
    formName: 'all',
  };

  const typeFilter = patientFormType[type] === 'all' ? {} : { type: patientFormType[type] };
  const variables = {
    filter: {
      ...typeFilter,
      _operators: {
        title: {
          regex: regex && `(?i)${regex}`,
        },
      },
    },
  };

  const handleOnSearchChange = (search: string) => setRegex(search);

  return (
    <React.Fragment>
      <FiltersSelectHeader type={type} onSearchChange={debounce(handleOnSearchChange, 600)} />
      <FilterPatientFormData type={type} variables={variables} />
    </React.Fragment>
  );
};

export default (props: FilterPatientFormProps) => (
  <React.Suspense fallback={<ChipLoader />}>
    <FilterPatientForm {...props} />
  </React.Suspense>
);
